// extracted by css-extract-rspack-plugin
export default {"root":"root-a8rT59","date":"date-aLlA7c","messages":"messages-C92NQo","chat":"chat-MpMcpF","shrinkChat":"shrinkChat-fdHpXS","expandChat":"expandChat-lEvoHr","prev":"prev-MAZDrk"};